import React from 'react';
import { INK } from '../styles';

interface Props {
  label: string;
  value: React.ReactNode;
}

export default function TableCell({ label, value }: Props) {
  return (
    <td style={{
      border: '1px solid ' + INK,
      padding: '10px 10px 24px',
      verticalAlign: 'top',
      width: '16.66%',
    }}>
      <div style={{ color: INK, fontWeight: 700, fontSize: 11 }}>{label}</div>
      <div style={{
        textAlign: 'right',
        fontWeight: 700,
        fontSize: 15,
        marginTop: 8,
        color: INK,
        fontVariantNumeric: 'tabular-nums',
      }}>
        {value}
      </div>
    </td>
  );
}